import actionTypes from '../web-sh/src/store/actionTypes';
export default {
  ...actionTypes,
  SET_PAYMENTS_PLAN: 'SET_PAYMENTS_PLAN',
  SET_PLAN_LIMIT: 'SET_PLAN_LIMIT',
  SET_PLAN_NOTICE_VISIBLE: 'SET_PLAN_NOTICE_VISIBLE',

  // Resource
  SET_COUNTRIES: "SET_COUNTRIES",
  SET_PLANS: "SET_PLANS",

  // Onboarding
  SET_ONBOARDING_PROCESS: "SET_ONBOARDING_PROCESS",
  SET_RELOAD_ONBOARDING: "SET_RELOAD_ONBOARDING",
  SET_WELCOME_VISIBLE: "SET_WELCOME_VISIBLE",
  SET_WELCOME_BUSINESS_VISIBLE: "SET_WELCOME_BUSINESS_VISIBLE",
  SET_TUTORIAL_PROCESS: "SET_TUTORIAL_PROCESS",
  SET_SHOW_TUTORIAL: "SET_SHOW_TUTORIAL",
  SET_GET_EXTENSION_VISIBLE: "SET_GET_EXTENSION_VISIBLE",
  SET_TUTORIAL_RUNNING: "SET_TUTORIAL_RUNNING",
  SET_STEP_INDEX: "SET_STEP_INDEX",
  SET_TUTORIAL_DETAIL_RUNNING: "SET_TUTORIAL_DETAIL_RUNNING",
  SET_STEP_DETAIL_INDEX: "SET_STEP_DETAIL_INDEX",

  // Enterprise
  SET_ENTERPRISE_INVITATIONS: "SET_ENTERPRISE_INVITATIONS",

  // Private Email
  SET_SELECTED_ALIAS: "SET_SELECTED_ALIAS",

  // Permission
  SET_SHOW_PREMIUM_ACTIONS: "SET_SHOW_PREMIUM_ACTIONS"
}